import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";
import type { Control } from "react-hook-form";
import type { MeetingFormValues } from "../../types/meeting-form";

interface MeetingLocationFieldProps {
  control: Control<MeetingFormValues>;
  isSubmitting: boolean;
  meetingType: string;
}

export const MeetingLocationField: React.FC<MeetingLocationFieldProps> = ({ 
  control, 
  isSubmitting,
  meetingType
}) => (
  <FormField
    control={control}
    name="location"
    render={({ field }) => (
      <FormItem>
        <FormLabel>
          <div className="flex items-center gap-2">
            <MapPin size={16} />
            {meetingType === "in_person" && "Location"}
            {meetingType === "video_call" && "Meeting Link"}
            {meetingType === "other" && "Location/Details"}
          </div>
        </FormLabel>
        <FormControl>
          <Input
            placeholder={
              meetingType === "in_person"
                ? "Address or meeting room"
                : meetingType === "video_call"
                  ? "Zoom, Teams, or other meeting link"
                  : "Location or connection details"
            }
            {...field}
            disabled={isSubmitting}
          />
        </FormControl>
        <FormDescription>
          {meetingType === "in_person" && "Physical address or room number"}
          {meetingType === "video_call" &&
            "Video conference link or dial-in details"}
          {meetingType === "other" && "Connection details or location information"}
        </FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
);
